// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"fd0f2399","426":"bb297d94","677":"5dda2a4e","874":"4d7ef31f"}[chunkId] + ".chunk.js";
};